import { useContext, createContext, useState } from "react"
import type { ReactElement, ReactNode } from "react"

import type { Proposal } from "query/graphql"

type ProposalContextValues = {
  proposal: Proposal
  isIncludePendingVotes: boolean
  setIsIncludePendingVotes: (value: boolean) => void
}

const ProposalContext = createContext<ProposalContextValues | undefined>(
  undefined,
)

type ProposalProviderProps = {
  children: ReactNode
  proposal: Proposal
}
export const ProposalProvider = ({
  children,
  proposal,
}: ProposalProviderProps): null | ReactElement => {
  const [isIncludePendingVotes, setIsIncludePendingVotes] = useState(false)

  const value = {
    isIncludePendingVotes,
    setIsIncludePendingVotes,
    proposal,
  }

  return (
    <ProposalContext.Provider value={value}>
      {children}
    </ProposalContext.Provider>
  )
}

export const useProposal = (): ProposalContextValues => {
  const context = useContext(ProposalContext)

  if (!context)
    throw new Error("ProposalContext must be used within ProposalProvider")

  return context
}
